import React, { useEffect, useState } from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import { useAnimation, motion, AnimatePresence } from "framer-motion"
import { useInView } from "react-intersection-observer"
import { Link } from "gatsby"
import ReactPlayer from "react-player"
import Spinner from "../components/spinner"

const motionSection = {
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      staggerChildren: 0.15,
      staggerDirection: 1,
      delay: 0.3,
      ease: [0.38, 0.005, 0.215, 1],
      when: "beforeChildren",
    },
  },
  initial: {
    opacity: 0,
    // y: 20
  },
}

const imgOverlay = {
  initial: { opacity: 1 },
  animate: {
    // right: "100%",
    opacity: 0,
    transition: {
      ease: [0.38, 0.005, 0.215, 1],
      duration: 0.6,
    },
  },
  closed: {
    // y: 0,
    opacity: 0,
    transition: {
      ease: [0.38, 0.005, 0.215, 1],
      duration: 0.6,
    },
  },
}
const heroImg = {
  initial: { scale: 1.2 },
  // opacity: 1,
  animate: {
    scale: 1,
    opacity: [1, 1, 0],
    // opacity: 0,
    transition: {
      ease: [0.38, 0.005, 0.215, 1],
      duration: 0.6,
    },
  },
  closed: {
    y: 0,
    opacity: 0,
    transition: {
      ease: [0.38, 0.005, 0.215, 1],
      duration: 0.6,
    },
  },
}

const motionText = {
  initial: { y: 20, opacity: 0 },
  animate: {
    y: 0,
    opacity: 1,
    transition: {
      ease: [0.38, 0.005, 0.215, 1],
      duration: 0.6,
      delay: 1,
    },
  },
}

const heroVideo = ({ block, raw, index }) => {
  const { unmute, heading, text, videoUrl, image, label, ctaLabel, ctaLink } =
    block
  const controls = useAnimation()
  const [ref, inView] = useInView()

  useEffect(() => {
    if (inView) {
      controls.start("animate")
    }
  }, [controls, inView])

  const [ready, setReady] = useState(false)
  const [muted, setMuted] = useState(true)

  console.log("ready", ready)

useEffect(() => {
  setTimeout(() => setReady(true), 5000)

}, [ready])



  

  return (
    <motion.section
      className="section module-hero overflow-hidden"
      ref={ref}
      animate={controls}
      initial="hidden"
      variants={motionSection}
    >
      
      <motion.div className="module-hero__img relative overflow-hidden">
     
        <div className="module-hero__img relative overflow-hidden aspect-w-16 aspect-h-9 ">
          <ReactPlayer
            // onReady={() => handleReady()}
            // onError={() => setReady(false)}
            url={videoUrl}
            playsinline={true}
            muted={muted}
            volume={1}
            controls={false}
            playing={true}
            loop={true}
            width="100%"
            height="100%"
            className="overflow-hidden"
          />
          
          <AnimatePresence>
            <motion.div initial={{opacity: 1}}  animate={{opacity: 0}} exit={{opacity: 0}} transition={{duration: .5, delay: 2}}>
              <GatsbyImage
                image={image.asset.gatsbyImageData}
                alt={image.asset.altText}
                className="w-full object-cover"
              />
            </motion.div>
            
            <motion.div  initial={{opacity: 1}}  animate={{opacity: 0}} exit={{opacity: 0}} transition={{duration: .5, delay: 2}} className="absolute flex items-center justify-center pointer-events-none">
              <Spinner/>
            </motion.div>
            
          </AnimatePresence>
          {/* <img src={image.asset.publicUrl} alt={image.asset.altText} className={ready ? " opacity-0":"transition-opacity	duration-500 ease-out opacity-100"} />

            <GatsbyImage
              image={image.asset.gatsbyImageData}
              alt={image.asset.altText}
              className={ready ? " opacity-0":"transition-opacity	duration-500 ease-out opacity-100"}
            /> */}


           
         
        </div>

        {muted ? (
          <button
            onClick={() => setMuted(false)}
            className="absolute top-4 lg:top-8 right-4 lg:right-8 z-20"
          >
            <span className="btn-underline">sound on!</span>
          </button>
        ) : (
          <button
            onClick={() => setMuted(true)}
            className="absolute top-4 lg:top-8 right-4 lg:right-8 z-20"
          >
            <span className="btn-underline">mute</span>
          </button>
        )}

        <motion.div
          variants={imgOverlay}
          initial="initial"
          animate="animate"
          className="module-hero__img-overlay absolute inset-0 bg-orange-400/20 z-10"
        />
      </motion.div>
      
      <div className="module-hero__content container">
        <div className="max-w-[630px]">
          <motion.span
            variants={motionText}
            className="text-sm tracking-widest inline-block mb-4 text-white"
          >
            {label}
          </motion.span>
          <motion.h1 variants={motionText} className="h1">
            {heading}
          </motion.h1>
          <motion.p variants={motionText} className="">
            {text}
          </motion.p>
          {ctaLabel && (
            <motion.div variants={motionText}>
              <Link to={ctaLink.slug.current} className="btn-primary mt-8">
                {ctaLabel}
              </Link>
            </motion.div>
          )}
        </div>
      </div>
    </motion.section>
  )
}

export default heroVideo
